export default {
    trust: {
        label: 'Trust',
        columnTitle: 'Trust值',
        placeholder: '请输入 Trust，范围 0-1',
        required: '请输入 Trust',
        range: 'Trust 范围为 0-1，保留 2 位小数',
        reason: '修改原因',
        reasonRequired: '请填写修改原因',
        reasonPlaceholder: '请说明调整 Trust 的原因',
        edit: '修改 Trust',
        filter: {
            all: '全部 Trust',
            notDefault: 'Trust ≠ 1',
        },
        summary: '本页 Trust ≠ 1：{count} 条',
        updateSuccess: 'Trust 更新成功',
        updateFailed: 'Trust 更新失败',
        editActorTitle: '修改演员 Trust',
        editUserTitle: '修改用户 Trust',
    },
};
